module.exports = __webpack_public_path__ + "static/media/heart37.47796684.svg";